module.exports = __webpack_public_path__ + "static/img/preview.76225b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/suikoden-microsite/preview.png
// module id = 109
// module chunks = 2